import { Form, Formik } from 'formik'
import React from 'react'

import { InputSelect } from '@/components'
import { useAlertContext } from '@/context'
import { Options } from '@/forms/CreateTicket/CreateTicket.util'
import { TicketMutations } from '@/graphql/mutations/ticket.mutations'
import { useGraphqlMutation } from '@/hooks/useGraphql'
import useTicketReasons from '@/hooks/useTicketReasons/useTicketReasons'

type Props = {
  isTicketClosed: boolean
  refetchDetails: () => void
  ticketId: number
  ticketReason: string | null
  ticketReasonId: number
  ticketTypeId: number
}

export const ReasonSelection = ({ ticketTypeId, isTicketClosed, ticketReasonId, ticketId, refetchDetails }: Props) => {
  const { setAlert } = useAlertContext()

  const { data: reasonsData } = useTicketReasons()

  const { mutate } = useGraphqlMutation(TicketMutations.updateTicket(), {
    onSuccess: () => {
      refetchDetails()
      setAlert('Reason updated', 'success')
    },
  })

  let ticketReasonsOptions: Options = [{ label: 'Select Reason', value: '' }]
  const ticketReasons = reasonsData && reasonsData.ticketReasons ? reasonsData.ticketReasons : []
  ticketReasonsOptions = ticketReasons
    .filter((reason) => reason.ticketTypeId === ticketTypeId)
    .map((reason) => {
      return { label: reason.description, value: reason.id }
    })

  const handleSubmit = (values: { ticketReasonId: number }) => {
    mutate({
      ticket: {
        ...values,
        ticketTypeId,
        ticketId,
      },
    })
  }

  return (
    <Formik
      initialValues={{
        ticketReasonId: ticketReasonId,
      }}
      onSubmit={handleSubmit}
    >
      {({ submitForm }) => {
        return (
          <Form className="flex w-1/2 flex-row flex-wrap">
            <InputSelect
              className="w-full"
              disabled={isTicketClosed}
              id="ticketReasonId"
              name="ticketReasonId"
              onChange={submitForm}
              options={ticketReasonsOptions}
              overviewDropdown={true}
            ></InputSelect>
          </Form>
        )
      }}
    </Formik>
  )
}
